var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconchat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2409_34659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4062 0.40918H3.59375C1.61216 0.40918 0 2.02134 0 4.00293V8.37793C0 10.2007 1.364 11.7109 3.125 11.9412V15.1225C3.125 15.3121 3.23919 15.4831 3.41438 15.5556C3.47234 15.5796 3.53328 15.5913 3.59366 15.5913C3.71563 15.5913 3.83553 15.5436 3.92519 15.454L7.4075 11.9717H12.4062C14.3878 11.9717 16 10.3595 16 8.37793V4.00293C16 2.02134 14.3878 0.40918 12.4062 0.40918ZM15.0625 8.37793C15.0625 9.84259 13.8709 11.0342 12.4062 11.0342H7.21334C7.089 11.0342 6.96978 11.0836 6.88191 11.1715L4.0625 13.9909V11.5029C4.0625 11.2441 3.85263 11.0342 3.59375 11.0342C2.12909 11.0342 0.9375 9.84259 0.9375 8.37793V4.00293C0.9375 2.53827 2.12909 1.34668 3.59375 1.34668H12.4062C13.8709 1.34668 15.0625 2.53827 15.0625 4.00293V8.37793Z",
    fill: "url(#paint0_linear_2409_34659)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 4.97656C3.47456 4.97656 2.84375 5.60741 2.84375 6.38281C2.84375 7.15822 3.47459 7.78906 4.25 7.78906C5.02541 7.78906 5.65625 7.15822 5.65625 6.38281C5.65625 5.60741 5.02541 4.97656 4.25 4.97656ZM4.25 6.85156C3.9915 6.85156 3.78125 6.64128 3.78125 6.38281C3.78125 6.12434 3.99153 5.91406 4.25 5.91406C4.50847 5.91406 4.71875 6.12434 4.71875 6.38281C4.71875 6.64128 4.5085 6.85156 4.25 6.85156Z",
    fill: "url(#paint1_linear_2409_34659)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4.97656C7.22456 4.97656 6.59375 5.60741 6.59375 6.38281C6.59375 7.15822 7.22456 7.78906 8 7.78906C8.77544 7.78906 9.40625 7.15822 9.40625 6.38281C9.40625 5.60741 8.77544 4.97656 8 4.97656ZM8 6.85156C7.74153 6.85156 7.53125 6.64128 7.53125 6.38281C7.53125 6.12434 7.74153 5.91406 8 5.91406C8.25847 5.91406 8.46875 6.12434 8.46875 6.38281C8.46875 6.64128 8.25847 6.85156 8 6.85156Z",
    fill: "url(#paint2_linear_2409_34659)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 4.97656C10.9746 4.97656 10.3438 5.60741 10.3438 6.38281C10.3438 7.15822 10.9746 7.78906 11.75 7.78906C12.5254 7.78906 13.1562 7.15822 13.1562 6.38281C13.1562 5.60741 12.5254 4.97656 11.75 4.97656ZM11.75 6.85156C11.4915 6.85156 11.2812 6.64128 11.2812 6.38281C11.2812 6.12434 11.4915 5.91406 11.75 5.91406C12.0085 5.91406 12.2188 6.12434 12.2188 6.38281C12.2188 6.64128 12.0085 6.85156 11.75 6.85156Z",
    fill: "url(#paint3_linear_2409_34659)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2409_34659",
    x1: 16.0514,
    y1: 20.0608,
    x2: -4.18144,
    y2: 12.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2409_34659",
    x1: 5.66529,
    y1: 8.61704,
    x2: 2.06598,
    y2: 7.36053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2409_34659",
    x1: 9.41529,
    y1: 8.61704,
    x2: 5.81598,
    y2: 7.36053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2409_34659",
    x1: 13.1653,
    y1: 8.61704,
    x2: 9.56598,
    y2: 7.36053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2409_34659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconchat);
export default __webpack_public_path__ + "static/media/iconchat.75db33b859b77a1d6dfe7c7e691b2d01.svg";
export { ForwardRef as ReactComponent };